<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-syllabus-button/course-syllabus-button.component.ts.CourseSyllabusButtonComponent.html